import {useMemo} from 'react';
import {
	getClosestSize,
	getSizedDims,
	ORIENTATION,
	SIZE_TYPE,
	type Size,
} from './utils';

export type UseAssetImageSizeParams = {
	asset?: {
		filewidth: number;
		fileheight: number;
		previewWidth: number;
		previewHeight: number;
	};
	containerWidth: number;
	containerHeight: number;
	forceImageSize?: Size;
};

export const useAssetImageSize = ({
	asset,
	containerWidth,
	containerHeight,
	forceImageSize,
}: UseAssetImageSizeParams) => {
	const imageSizeDetails = useMemo(() => {
		if (!asset || containerWidth === 0 || containerHeight === 0)
			return {
				size: forceImageSize || SIZE_TYPE.PREVIEW,
				dimensions: {
					width: 0,
					height: 0,
				},
			};

		const containerDims = {
			width: containerWidth,
			height: containerHeight,
		};

		const closestSize =
			forceImageSize ||
			getClosestSize(
				containerDims,
				asset.previewHeight > asset.previewWidth
					? ORIENTATION.PORTRAIT
					: ORIENTATION.LANDSCAPE,
			);

		return {
			size: closestSize,
			dimensions: getSizedDims(
				closestSize,
				{
					width: asset.filewidth || asset.previewWidth || 150,
					height: asset.fileheight || asset.previewHeight || 150,
				},
				containerDims,
			),
		};
	}, [
		asset?.fileheight,
		asset?.filewidth,
		asset?.previewHeight,
		asset?.previewWidth,
		containerWidth,
		containerHeight,
		forceImageSize,
	]);

	return imageSizeDetails;
};
